import React from 'react';
import { FadeIn } from '../components/ui/FadeIn';
import { Check } from 'lucide-react';
const ITEMS = ['Diario Completo de las 40 Semanas', 'Cartas Para Tu Bebé', 'Conversaciones Guiadas Mamá-Bebé', 'Ritual Nocturno de Conexión', 'Páginas Para Ecografías', 'Mi Promesa Como Mamá'];
export function WhatsInside() {
  return <section id="que-incluye" className="bg-brand-burgundy text-brand-cream py-20 mt-12" data-id="element-201">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-202">
        <FadeIn data-id="element-203">
          <h2 className="text-3xl md:text-4xl font-serif text-center text-brand-cream mb-12" data-id="element-204">
            Lo que encontrarás dentro
          </h2>

          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-3xl p-8 md:p-12" data-id="element-205">
            <ul className="grid sm:grid-cols-2 gap-6 md:gap-8" data-id="element-206">
              {ITEMS.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-207">
                  <div className="mt-1 bg-brand-rose/20 rounded-full p-1" data-id="element-208">
                    <Check className="w-5 h-5 text-brand-rose-light" strokeWidth={2.5} data-id="element-209" />
                  </div>
                  <span className="text-lg font-medium tracking-wide" data-id="element-210">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}